export var KEY_PREFIX = 'persist:';
export var FLUSH = 'persist/FLUSH';
export var REHYDRATE = 'persist/REHYDRATE';
export var PAUSE = 'persist/PAUSE';
export var PERSIST = 'persist/PERSIST';
export var PURGE = 'persist/PURGE';
export var REGISTER = 'persist/REGISTER';
export var DEFAULT_VERSION = -1;


//////////////////
// WEBPACK FOOTER
// ./~/redux-persist/es/constants.js
// module id = 144
// module chunks = 0